$.fn.stickyHeader = function() {
	var $me    = $(this),
		height = $me.offset().top;

	$(window).on('scroll', function() {
		var scrollTop = $(this).scrollTop();

		if(scrollTop >= height) {
			$me.addClass('sticky');
		} else {
			$me.removeClass('sticky');
		}
	});	
};

$('.site-nav').stickyHeader();

$('[data-menu]').on('click', function(e) {
	e.preventDefault();
	$('.site-nav').toggleClass('show');
});